import script from "./error.vue?vue&type=script&setup=true&lang=ts"
export * from "./error.vue?vue&type=script&setup=true&lang=ts"

import "./error.vue?vue&type=style&index=0&id=4416c4db&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4416c4db"]])

export default __exports__